import * as yup from 'yup'
import { HSLA_REGEXP, HSL_REGEXP, RGBA_REGEXP } from 'util/colors'

const COLOR_REGEXP = new RegExp(
  [RGBA_REGEXP.source, HSL_REGEXP.source, HSLA_REGEXP.source].join('|'),
  'i'
)

// NOTE (jscheel): Mimics what is in Colorable concern on backend
export const DEFAULT_COLORS = [
  'hsl(45, 76%, 57%)',
  'hsl(187, 69%, 53%)',
  'rgba(220, 86, 56, 1)',
  'rgba(145, 30, 180, 0.7)',
  'rgba(245, 130, 48, 0.7)',
  'rgba(230, 25, 75, 0.7)',
  'rgba(52, 130, 234, 0.7)',
  'rgba(210, 245, 60, 0.9)',
  'rgba(240, 50, 230, 0.7)',
  'rgba(70, 240, 240, 0.7)',
  'rgba(250, 190, 190, 0.7)',
  'rgba(0, 128, 128, 0.7)',
  'rgba(230, 190, 255, 0.7)',
  'rgba(170, 110, 40, 0.7)',
  'rgba(255, 250, 200, 0.7)',
  'rgba(128, 0, 0, 0.7)',
  'rgba(170, 255, 195, 0.7)',
  'rgba(128, 128, 0, 0.7)',
  'rgba(255, 215, 180, 0.7)',
  'rgba(0, 0, 128, 0.7)',
  'rgba(128, 128, 128, 0.7)',
  'rgba(0, 0, 0, 0.7)',
  'rgba(60, 180, 75, 0.7)',
  'rgba(255, 225, 25, 0.7)',
]

export default {
  google: {
    schema: yup.object().shape({
      id: yup.string().nullable(),
      name: yup.string().required(`${app.t('Mailbox')} name is required`),
      color: yup
        .string()
        .trim()
        .matches(COLOR_REGEXP, 'Invalid color')
        .required(`${app.t('Mailbox')} color is required`),
    }),
    showEmail: false,
    formEmptyState: {
      id: null,
      name: '',
      color: 'rgba(89,208,21,1)',
      channel_type: 'GOOGLE',
    },
  },
  messenger: {
    schema: yup.object().shape({
      id: yup.string().nullable(),
      name: yup.string().required(`${app.t('Mailbox')} name is required`),
      color: yup
        .string()
        .trim()
        .matches(COLOR_REGEXP, 'Invalid color')
        .required('Channel color is required'),
    }),
    showEmail: false,
    formEmptyState: {
      id: null,
      name: '',
      color: 'rgba(89,208,21,1)',
    },
  },
  forwarding: {
    schema: yup.object().shape({
      id: yup.string().nullable(),
      email: yup
        .string()
        .email(`${app.t('Mailbox')} email is invalid`)
        .required(`${app.t('Mailbox')} email is required`),
      name: yup.string().required(`${app.t('Mailbox')} name is required`),
      color: yup
        .string()
        .trim()
        .matches(COLOR_REGEXP, 'Invalid color')
        .required(`${app.t('Mailbox')} color is required`),
    }),
    showEmail: true,
    formEmptyState: {
      id: null,
      email: '',
      name: '',
      color: 'rgba(89,208,21,1)',
      channel_type: 'FORWARDING',
    },
  },
  legacy: {
    schema: yup.object().shape({
      id: yup.string().nullable(),
      email: yup
        .string()
        .email(`${app.t('Mailbox')} email is invalid`)
        .required(`${app.t('Mailbox')} email is required`),
      name: yup.string().required(`${app.t('Mailbox')} name is required`),
      color: yup
        .string()
        .trim()
        .matches(COLOR_REGEXP, 'Invalid color')
        .required(`${app.t('Mailbox')} color is required`),
    }),
    showEmail: true,
    formEmptyState: {
      id: null,
      email: '',
      name: '',
      color: 'rgba(89,208,21,1)',
      channel_type: 'LEGACY',
    },
  },
}
